// src/themes/dark.js
import { createTheme } from '@mui/material/styles';
import { BG_SURFACE, BG_BASE, BRAND_PURPLE, BRAND_TEAL, TEXT_PRIMARY, TEXT_SECONDARY, BORDER_SECTION } from '../utils/colors';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      paper: BG_SURFACE,
      darker: BG_BASE,
    },
    primary: {
      main: BRAND_PURPLE,
    },
    secondary: {
      main: BRAND_TEAL,
    },
    text: {
      primary: TEXT_PRIMARY,
      secondary: TEXT_SECONDARY,
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${BORDER_SECTION}`,
          padding: '3px 4px',
          fontSize: '0.65rem',
        },
        head: {
          fontWeight: 600,
          color: TEXT_SECONDARY,
        },
      },
    },
  },
});

export default darkTheme;
